import * as jdApi from './jd.js'
import * as taoApi from './tao.js'
let api = Object.assign(taoApi,jdApi)

export default api



// WEBPACK FOOTER //
// ./src/api/index.js